import { useState } from 'react';

const useZeroAmountNotificationDialog = () => {
  const [zeroAmountNotificationDialogIsOpen, changeZeroAmountNotificationDialogIsOpen] = useState(false);

  const openZeroAmountNotificationDialog = async () => {
    changeZeroAmountNotificationDialogIsOpen(true);
    await new Promise((resolve) => setTimeout(resolve, 6000));
    changeZeroAmountNotificationDialogIsOpen(false);
  };

  return { zeroAmountNotificationDialogIsOpen, openZeroAmountNotificationDialog };
};

export default useZeroAmountNotificationDialog;
